export const PRODUCT_LOADING="PPRODUCT_LOADING"

export const PRODUCT_FAILURE="PPRODUCT_FAILURE";

export const FETCH_FURNITURES="FETCH_FURNITURE"
export const FETCH_ELECTRONICS="FETCH_ELECTRONICS"
export const FETCH_FOOTWEARS="FETCH_FOOTWEARS"